import type { ValueOf } from 'type-fest';

export const MOBILE_HANDOFF_TYPES = {
  TOUR_ADDED_SUCCEEDED: 'tourAddedSucceeded',
  SUCCESSFUL_POST_TOUR_LINK_CLICK: 'successfulPostTourLinkClick',
} as const;

export type MOBILE_HANDOFF_TYPES = ValueOf<typeof MOBILE_HANDOFF_TYPES>;

export const mobileHandoffHandler = (postMessageType: MOBILE_HANDOFF_TYPES, meta?: Record<string, unknown>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const iosWebkit = (window as any).webkit;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const androidZrmNativeApi = (window as any).ZRM_NATIVE_API;

  //iOS
  if (iosWebkit?.messageHandlers?.ZRM_NATIVE_API) {
    return iosWebkit.messageHandlers.ZRM_NATIVE_API.postMessage(postMessageType, meta);
  }
  //Android
  if (androidZrmNativeApi) {
    return androidZrmNativeApi.postMessage(postMessageType);
  }
};
